import { useSuspenseQuery } from '@tanstack/react-query';
import { SourcingAnalytics, SourcingService } from 'api-clients/monolith';

import { queryKeys } from '@/query-keys';

import { MetricIndicator } from './metric-indicator';

const METRIC_ORDER: (keyof SourcingAnalytics)[] = [
  'budget_spent',
  'hired_count',
  'average_cph',
  'applied_count',
  'average_cpa',
];

interface MetricsProps {
  fromDate: string;
  toDate: string;
}

export function Metrics({ fromDate, toDate }: MetricsProps) {
  const {
    data: { analytics: analyticsData },
  } = useSuspenseQuery({
    queryKey: [...queryKeys.dashboard.analytics, fromDate, toDate],
    queryFn: () =>
      SourcingService.getInternalApiSourcingDashboardAnalytics(
        fromDate,
        toDate,
      ),
  });

  return (
    <div className="flex flex-row justify-between px-6 py-4">
      {METRIC_ORDER.map(key => (
        <MetricIndicator key={key} metricKey={key} value={analyticsData[key]} />
      ))}
    </div>
  );
}

Metrics.Skeleton = function MetricsSkeleton() {
  return (
    <div className="flex flex-row justify-between px-6 py-4">
      {METRIC_ORDER.map(key => (
        <MetricIndicator.Skeleton key={key} metricKey={key} />
      ))}
    </div>
  );
};
